




























import { Component, Watch, Provide, Prop, Vue } from 'vue-property-decorator';

type TInterpretationCategories = {
  type: string;
  name: string;
  sentence?: any;
  sentenceLevel?: any;
  strongFoot?: any;
  angles?: any;
};

@Component
export default class ElementBlocOldInterpretation extends Vue {
  @Prop({ required: false }) private validateAlgorithm!: boolean;
  @Prop({ required: false }) private recommendations!: any;
  @Prop({ required: true }) private choosingCateg!: string;
  @Prop({ required: true }) private generalInterpretation!: boolean;

  @Provide() category: any = [];
  @Provide() recommendationCategories: TInterpretationCategories[] = [
    {
      type: 'generals',
      name: 'general',
      sentence: '',
      strongFoot: '',
      sentenceLevel: 0,
    },
    {
      type: 'swingPhase',
      name: 'oscillating-phase',
      sentence: '',
      strongFoot: '',
      sentenceLevel: 0,
    },
    {
      type: 'stancePhase',
      name: 'stance-phase',
      angles: { left: [], right: [] },
    },
  ];

  get isGoodAngles() {
    return !!this.recommendations.find((x: any) => x.id.includes('HS'));
  }
  // When choosing category change
  @Watch('choosingCateg')
  onChangeCateg(id: string) {
    this.category = this.recommendationCategories.filter((categ) => categ.type === id).pop();
  }
  // When acquisition change
  @Watch('recommendations')
  onChangeRecommendations() {
    if (this.recommendations && this.validateAlgorithm) this.implementRecommendations();
  }

  mounted() {
    if (this.recommendations && this.validateAlgorithm) this.implementRecommendations();
    this.category = this.recommendationCategories.filter((categ) => categ.type === this.choosingCateg).pop();
  }

  // Get recommendations for categories
  get general_recommendations() {
    // Sort by name
    const data = this.recommendations.filter((x: any) => x.id.includes('GENERAL')).pop();
    return {
      sentence: this.getSentenceForGeneral(data), // Sentence
      strongFoot: this.getStrongFoot(data), // Strong foot
      level: this.getLevel(data.level), // Level
    };
  }
  get oscillating_recommendations() {
    // Sort by name
    const data = this.recommendations.filter((x: any) => x.id.includes('OSCILLATION')).pop();
    return {
      sentence: this.getSentenceForGeneral(data), // Sentence
      strongFoot: this.getStrongFoot(data), // Strong foot
      level: this.getLevel(data.level), // Level
    };
  }
  get angle_recommendations() {
    // Sort by name
    const data = this.recommendations.filter((x: any) => x.id.includes('ANGLE'));
    return this.isGoodAngles ? this.sortAngleData(data) : null;
  }

  // Add new recommendation structure in categories
  implementRecommendations() {
    this.recommendationCategories[0].sentence = this.general_recommendations.sentence; // GENERAL
    this.recommendationCategories[0].strongFoot = this.general_recommendations.strongFoot; // GENERAL
    this.recommendationCategories[0].sentenceLevel = this.general_recommendations.level; // GENERAL

    this.recommendationCategories[1].sentence = this.oscillating_recommendations.sentence; // SWING
    this.recommendationCategories[1].strongFoot = this.oscillating_recommendations.strongFoot; // SWING
    this.recommendationCategories[1].sentenceLevel = this.oscillating_recommendations.level; // SWING

    if (this.isGoodAngles) {
      this.recommendationCategories[2].angles.left = this.angle_recommendations.left; // STANCE
      this.recommendationCategories[2].angles.right = this.angle_recommendations.right; // STANCE
    }
  }

  // Transform code into sentence
  getSentenceForGeneral(data: any) {
    let sentence;

    // Exceptional cases
    if (data.id.includes('_0')) sentence = null;
    else if (data.id.includes('OSCILLATION_PHASE_TEXT_14'))
      sentence = data.id.toLowerCase() + '_' + this.getLegSide(data.side);
    else if (data.id.includes('GENERAL_PARAMETERS_TEXT_3'))
      sentence = data.id.toLowerCase() + '_' + this.getLevel(data.level2);
    // General cases
    else sentence = data.id.toLowerCase();

    return sentence;
  }

  // Sort angle data
  sortAngleData(data: any) {
    const angles: any = {
      left: [],
      right: [],
    };
    const steps = [
      { id: 'HS', name: 'heel-strike' },
      { id: 'FFI', name: 'flat-foot' },
      { id: 'HO', name: 'heel-off' },
      { id: 'TO', name: 'toe-off' },
    ];
    for (const side of ['left', 'right']) {
      for (const step of steps) {
        const angleInfos = data.filter((item: any) => item.id.includes(step.id) && item.side === side).pop();
        angles[side].push({
          name: this.$t('commons.standards.' + step.name),
          sentence: this.getSentenceForAngles(angleInfos),
        });
      }
    }
    return angles;
  }
  getSentenceForAngles(item: any) {
    const angleText = 'angle_text.' + item.side + '.' + item.id.toLowerCase().substring(13, item.id.length);
    const angleLevel = item.id.substring(11, 12);
    return this.$tc(`interpretations.${angleText}`, angleLevel);
  }

  // Transform code into strong foot
  getStrongFoot(data: any) {
    if (data.side) {
      return 'interpretations.strong_foot_' + data.side;
    } else {
      return null;
    }
  }
  // Get level code
  getLevel(level: string) {
    switch (level) {
      case 'WEAK':
        return 0;
      case 'MEDIUM':
        return 1;
      case 'STRONG':
        return 2;
      default:
        return 0;
    }
  }
  // Get side code
  getLegSide(side: string) {
    if (side === 'left') return 1;
    return 2;
  }
  // Get alert color depending on level
  getLevelColor(level: number) {
    switch (level) {
      case 1:
        return 'warning';
      case 2:
        return 'error';
      default:
        return 'accent';
    }
  }
}
